import React, { useState } from "react";
import { Line } from "react-chartjs-2"; 
import { Card, CardBody } from "reactstrap";

import CardHeader from "../Layout/CardHeader";
import SuperInsightsModal from "../Ia/SuperInsightsModal";
import Meta from '../Layout/Meta';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

const LineChart = ({ item }) => {

const safeItem = item || {};

const {
      Sigla = '',
      Descricao_Dashboard_Componente: titulo = "-",
      dadosComponente = {},  
      Valor_Meta = {},
      Texto_Info = "-",
      Texto_BizAI = "",
      ESG_Info = "-",
      Codigo_Transacao_Link = "",
      Titulo_Transacao_Link = "",
      opcoesComponente = {},  
   } = safeItem;
  
const [isPopupOpen, setIsPopupOpen] = useState(false);
const togglePopup = () => setIsPopupOpen(!isPopupOpen);
const slugId = Sigla.trim().replace(/\s+/g, "-");

const baseOpts    = opcoesComponente || {};
const basePlugins = baseOpts.plugins       || {};
const baseScales  = baseOpts.scales        || {};
const baseX       = baseScales.x           || {};
const baseXTicks  = baseX.ticks            || {};
const baseY       = baseScales.y           || {};
const baseYTicks  = baseY.ticks            || {};

const formatCurrencyCompactBR = (value) => {
  const n = Number(value);
  if (!isFinite(n)) return value;
  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  const fmt = (den) => (abs / den).toLocaleString('pt-BR', {
    minimumFractionDigits: abs < den * 10 ? 1 : 0,
    maximumFractionDigits: abs < den * 10 ? 1 : 0
  });
  if (abs >= 1e9) return `${sign}R$ ${fmt(1e9)} bi`;
  if (abs >= 1e6) return `${sign}R$ ${fmt(1e6)} mi`;
  if (abs >= 1e3) return `${sign}R$ ${fmt(1e3)} mil`;
  return `${sign}R$ ${abs.toLocaleString('pt-BR', { maximumFractionDigits: 0 })}`;
};

const chartOptions = {
  ...baseOpts,
  layout: {
    ...(baseOpts.layout || {}),
    padding: {
      ...((baseOpts.layout || {}).padding || {}),
      bottom: 0
    }
  },
  plugins: {
    ...basePlugins,
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        font: {
          family: 'Poppins, sans-serif',
          size: 10,
          weight: '400',
          color: '#000'
        },
        usePointStyle: true,
        padding: 20
      }
    },
    tooltip: {
      mode: 'index',
      intersect: false,
      backgroundColor: '#fff',
      borderColor: '#ccc',
      borderWidth: 1,
      titleColor: '#666',
      bodyColor: '#000',
      displayColors: true,
      usePointStyle: true,
      titleFont: {
        family: 'Poppins, sans-serif',
        size: 8,
        weight: '700'
      },
      bodyFont: {
        family: 'Poppins, sans-serif',
        size: 9,
        weight: '600'
      },
      callbacks: {
        title: items => items[0].label,
        label: ctx => {
          const v = ctx.parsed.y;
          return `${ctx.dataset.label}: ${formatCurrencyCompactBR(v)}`;
        },
        labelColor: ctx => ({
          borderColor: 'transparent',
          backgroundColor: ctx.dataset.borderColor,
          borderWidth: 0,
          width: 10,
          height: 10,
          borderRadius: 5
        })
      }
    }
  },
  scales: {
    x: {
      ...baseX,
      ticks: {
        ...baseXTicks,
        font: {
          family: 'Poppins, sans-serif',
          weight: '600',
          size: 9
        }
      }
    },
    y: {
      ...baseY,
      position: 'left',
      beginAtZero: true,
      ticks: {
        ...baseYTicks,
        font: {
          family: 'Poppins, sans-serif',
          size: 9
        },
        callback: val => formatCurrencyCompactBR(val)
      },
      grid: {
        drawOnChartArea: true
      }
    }
  }
};


  return (
    <>
      <Card className="w-100 h-100 ">
        <CardBody className="w-100 h-100 d-flex flex-column pb-0">
          <CardHeader
            titulo={titulo}
            Texto_Info={Texto_Info}
            ESG_Info={ESG_Info}
            togglePopup={togglePopup}
            slugId={slugId}
            textoIA={Texto_BizAI}
            Codigo_Transacao_Link={Codigo_Transacao_Link}
            Titulo_Transacao_Link={Titulo_Transacao_Link}
        />
        <Meta Valor_Meta={Valor_Meta} />
        
         
        <div style={{ marginTop: 6, height: '100%' }}>
          <Line data={dadosComponente} options={chartOptions} />
        </div>
      </CardBody>
    </Card>
    
    <SuperInsightsModal
        isOpen={isPopupOpen}
        toggle={togglePopup}
        textoIA={Texto_BizAI} // Passamos somente o texto da pergunta
      />
    </>
  );
};

export default LineChart;